export const REFERRAL_ADDRESS = '0xf0D7f86B0316e0E57e214aC7a5Be4a42becc073d'
export const RESET_STAGE_TIME = 3000

// from lido repo https://github.com/lidofinance/ethereum-staking-widget/blob/develop/consts/tx.ts
export const FALLBACK_STAKE_GAS_LIMIT = 100_000n
export const FALLBACK_WRAP_ETH_GAS_LIMIT = 100_000n
export const FALLBACK_WRAP_STETH_GAS_LIMIT = 140_000n
export const FALLBACK_UNWRAP_GAS_LIMIT = 115_000n
export const ESTIMATE_ACCOUNT = '0x87c0e047F4e4D3e289A56a36570D4CB957A37Ef1'

export const DEFAULT_WITHDRAWAL_WAITING_TIME_DAYS = 5

export const FALLBACK_WITHDRAWAL_REQUEST_STETH_PERMIT_GAS_LIMIT = 255_350n
export const FALLBACK_WITHDRAWAL_REQUEST_WSTETH_PERMIT_GAS_LIMIT = 312_626n
export const FALLBACK_WITHDRAWAL_REQUEST_STETH_APPROVED_GAS_LIMIT = 228_163n
export const FALLBACK_WITHDRAWAL_REQUEST_WSTETH_APPROVED_GAS_LIMIT = 280_096n
export const FALLBACK_WITHDRAWAL_REQUEST_CLAIM_GAS_LIMIT = 89_818n

export const MAX_WITHDRAWAL_REQUESTS_COUNT = 256
export const MAX_WITHDRAWAL_SHOWN_REQUEST_PER_TYPE = 1024
